import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const SkladOV = {
	name: NAME,
	apiProvider,
	router,
};
